import React from 'react';

const InvestmentsOwnerFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.5 2.5H5.5C5.10218 2.5 4.72064 2.65804 4.43934 2.93934C4.15804 3.22064 4 3.60218 4 4V16C4 16.3978 4.15804 16.7794 4.43934 17.0607C4.72064 17.342 5.10218 17.5 5.5 17.5H14.5C14.8978 17.5 15.2794 17.342 15.5607 17.0607C15.842 16.7794 16 16.3978 16 16V7L11.5 2.5Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 8.5V15.375" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M11.5625 9.75H9.21875C8.92867 9.75 8.65047 9.86523 8.44535 10.0704C8.24023 10.2755 8.125 10.5537 8.125 10.8438C8.125 11.1338 8.24023 11.412 8.44535 11.6171C8.65047 11.8223 8.92867 11.9375 9.21875 11.9375H10.7812C11.0713 11.9375 11.3495 12.0527 11.5546 12.2579C11.7598 12.463 11.875 12.7412 11.875 13.0312C11.875 13.3213 11.7598 13.5995 11.5546 13.8046C11.3495 14.0098 11.0713 14.125 10.7812 14.125H8.125"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M11.5 2.5V7H16" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default InvestmentsOwnerFilterIcon;
